import { useFetchPatientInfo } from '@/api/hooks/useFetchPatientInfo'
import { HomeTiles } from '@/components/HomePage/HomeTiles'
import { TabScreenHeader } from '@/components/TabScreenHeader'
import { useHomeTiles } from '@/features/home/useHomeTiles'
import heapService from '@/services/heap'
import { PageShell } from '@/ui/core/page-shell'
import { Screen } from '@/ui/core/screen'
import { isEmpty } from 'ramda'
import { useEffect } from 'react'
import Images from '#/assets/images/image-map'

export default function HomeScreen() {
	const { patientInfo } = useFetchPatientInfo()
	const { tiles, refetchVisits } = useHomeTiles()

	useEffect(() => {
		if (!isEmpty(patientInfo)) {
			heapService.identify(patientInfo)
		}
	}, [patientInfo])

	return (
		<Screen preset="fixed" className="flex flex-1" safeAreaEdges={[]}>
			<PageShell photo={Images.Bubbles} contentClassName="pt-1">
				<TabScreenHeader />
				<HomeTiles tiles={tiles} onRetryVisits={() => refetchVisits()} />
			</PageShell>
		</Screen>
	)
}
